// components/Layout.tsx
// import React, { ReactNode } from 'react';
import { ThemeProvider } from './ThemeContext';
import { Navbar } from './Navbar';
import Sidebar  from './Sidebar';
import { User, NavigationItem } from './Ttype';
import Navbar0 from '../../../../vitrine/Components/Navbar';
// import Navbar0 from '../../../../vitrine/Components/Navbar';

interface LayoutProps {
  // children: ReactNode;
  currentUser?: User;
  navigation?: NavigationItem[];
  onLogout?: () => void;
}

export const Layout: React.FC<LayoutProps> = ({ 
  // children,
 

}) => {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar0/>
        <Navbar />
        <Sidebar />
        <main className="pt-16 pl-64 max-h-screen ">
          <div className="p-6 ">
            {/* {children} */}
          </div>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default Layout;